import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CustomerConnection',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CustomerConnection',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CustomerConnection',
    column_type: 'datetime',
  },
  name: {
    model_name: 'CustomerConnection',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
